import { TransactionType } from '@libs/types';

export const UNVERIFIED_USER_TITLE = {
  [TransactionType.Deposit]: 'deposit_disclaimer_kyc_required',
  [TransactionType.Withdrawal]: 'withdraw_disclaimer_kyc_required',
  [TransactionType.Buy]: 'buy_crypto_kyc_warning',
};
